// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"494511dc","455":"3539a7a6","977":"12293fc9"}[chunkId] + ".chunk.js";
};